if(window.innerWidth>750){
    var wFlag=true
}else{
    wFlag=false
}

$(()=>{
    if(wFlag){
        gsap.from('.box2_subtitle',{
            scale:0,ease:'power1',duration:0.5,
            scrollTrigger:{
                trigger:'.box2_subtitle',
                start:'top bottom-=20%',
                end:'+=0',
                toggleActions:'play none none reverse',
                // markers:true
            }
        })
    
        ScrollTrigger.create({
            trigger:'.box2',
            start:'top top+=5%',
            end:'+=250%',
            pin:true,
            scrub:1,
            //markers:true,
            animation:gsap.timeline()
                .to('.box2_title',{x:'0',duration:0.1})
                .to('.box2_subtitle',{x:0,duration:0.1},'<')
                .to('.box2_text',{opacity:1,y:'0',duration:0.2})
                .to('.box2_text div',{backgroundSize:'100% 100%',duration:0.8})
                .to('.box2_img',{y:'0',duration:0.8},'<')
        })
    
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top+=5%',
            end:'+=100%',
            pin:true,
            scrub:1,
            //markers:true,
            animation:gsap.timeline()
                .to('.box3_bg',{scale:0.6,borderRadius:'4rem',opacity:0.5})
                .from('.box3_title',{y:'2rem',opacity:0})
        })
    }else{
        showUp('.box2_title')
        showUp('.box2_subtitle')
    
        ScrollTrigger.create({
            trigger:'.box2',
            start:'top top+=5%',
            end:'+=150%',
            pin:true,
            scrub:1,
            //markers:true,
            animation:gsap.timeline()
                .to('.box2_text div',{backgroundSize:'100% 100%'})
                .to('.box2_img',{x:'-76%'},'<')
        })

        showUp('.box3_title')
    }

    showUp('.box4_title')
})